import _ from 'lodash'
import $ from 'jquery'
import Backbone from 'backbone'
import enums from 'scoreboard/components/enums'
import MultichoiceFilter from 'scoreboard/reports/common/filter/multichoice-filter'
import multichoiceCheckboxTemplate from 'scoreboard/reports/common/filter/multichoice-checkbox-filter.hbs'
import template from './color-filter.hbs'
import PeriodRangeDateFilter from './period-range-date-filter'
import * as scoreboardColors from 'scoreboard-colors'
import constants from 'scoreboard/components/constants'
const { BORDER_WIDTH } = constants

function circle(opt = {}) {
	let border = scoreboardColors.adjustLightness(opt.color, -20)
	return `<div class="color-icon" style="background-color: #${opt.color};
		border: ${BORDER_WIDTH} solid ${border}"></div>`
}

var ColorFilter = Backbone.View.extend({

	//this.data is a MultiChoiceAppliesToDateFilter which is a java POJO

	className: 'color-filter',

	initialize: function(options) {
		this.options = options
		this.options.isCheckboxFilter = true
		this.data = _.cloneDeep(this.options.data)

		this.choices = _.map(this.options.seedData, jsonHexPair => {
			let jsonValue = jsonHexPair.first
			let label = enums.scoreColor[jsonValue] || jsonHexPair.second
			let preLabelHtml = circle({color: jsonHexPair.second})
			return {id: jsonValue, label, preLabelHtml}
		})

		this.multichoice = new MultichoiceFilter(_.defaults({
			template: multichoiceCheckboxTemplate,
			customTemplate: true,
			choices: this.choices
		}, options))
		this.formViewType = this.multichoice.formViewType
		this.periodRangeDateFilter = new PeriodRangeDateFilter(options)
	},

	render: function() {
		var content = template()
		this.$el.html($(content))
		this.$('.multichoice').append(this.multichoice.render().$el)

		this.periodRangeDateFilter.setElement(this.$('.applies-to-container')).render()

		return this
	},

	//returns the data captured by this filter
	gather: function() {
		_.extend(this.data, this.multichoice.gather(), this.periodRangeDateFilter.gather())
		return this.data
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.multichoice, this.periodRangeDateFilter], 'remove')
	}

})

export default ColorFilter

ColorFilter.__filename__ = 'reports/wizard/filter-meta/color-filter.js'
